import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=f8acc6fe&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"
import style0 from "./Story.vue?vue&type=style&index=0&id=f8acc6fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8acc6fe",
  null
  
)

export default component.exports